import dayjs from 'dayjs';

/**
 * Formats a date value to display both date and time components in a user-friendly format.
 * 
 * @param {Date|string|null|undefined} dateValue - The date value to format. Can be a Date object, 
 *                                                  ISO string, or null/undefined.
 * @returns {string} Formatted date string in "MMM D, YYYY HH:mm" format (e.g., "Aug 5, 2025 21:37")
 *                   or empty string if the input is null/undefined/invalid.
 * 
 * @example
 * formatDateTime(new Date('2025-08-05T21:37:00Z')) // Returns "Aug 5, 2025 21:37"
 * formatDateTime(null) // Returns ""
 * formatDateTime(undefined) // Returns ""
 */
export const formatDateTime = (dateValue) => {
    if (!dateValue) {
        return '';
    }
    
    const date = dayjs(dateValue);
    if (!date.isValid()) {
        return '';
    }
    
    // Format as "MMM D, YYYY HH:mm" using local timezone
    return date.format('MMM D, YYYY HH:mm');
};